import requestDefaults from 'superagent-defaults';
import Request from 'superagent';
import superagentPromise from 'superagent-promise';
import Cookies from 'js-cookie';

const RequestPromise = superagentPromise(Request, Promise);

const defaultedRequest = requestDefaults(RequestPromise)
  .set('Accept', 'application/json')
  .set('X-Requested-With', 'XMLHttpRequest');

const proxiedRequest = window.Proxy
  ? (function () {
      // csrf token needs to be reset on every single request. Not just on first load of the javascript.
      // if a user logs out and logs in again in another tab, the csrf token cookie will change.

      const handler = {
        get: (obj, prop) => {
          return obj.set('X-CSRFToken', Cookies.get('csrftoken'))[prop];
        },
      };
      return new window.Proxy(defaultedRequest, handler);
    })()
  : defaultedRequest;

export default proxiedRequest;
